import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModeratorsComponent } from './table-moderators.component';
import {PreloaderModule} from "../../components/preloader/preloader.module";
import {PaginationModule} from "../../components/pagination/pagination.module";
import {SmartTableModule} from "../../modules/smart-table/smart-table.module";
import {PortalModule} from "@angular/cdk/portal";
import {RouterModule} from "@angular/router";
import {IconsModule} from "../../components/icons/icons.module";
import {BadgeExistModule} from "../../components/badge-exist/badge-exist.module";
import {ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../../../modules/shared.module";
import {BtnDeleteModule} from "../../components/btn-delete/btn-delete.module";
import {FormGroupSimpleModule} from "../../modules/form-group-context/form-group-simple/form-group-simple.module";



@NgModule({
  declarations: [TableModeratorsComponent],
  exports: [
    TableModeratorsComponent
  ],
  imports: [
    CommonModule,
    PreloaderModule,
    PaginationModule,
    SmartTableModule,
    PortalModule,
    RouterModule,
    IconsModule,
    BadgeExistModule,
    ReactiveFormsModule,
    SharedModule,
    BtnDeleteModule,
    FormGroupSimpleModule
  ]
})
export class TableModeratorsModule { }
